module.exports = __webpack_public_path__ + "img/header_bg.dacd1276.png";